module.exports = __webpack_public_path__ + "media/images/frontend/quedateencasa-32f1a2b4f0c080eedfda40d8a9fe44dc.svg";